import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    margin-bottom: 15px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledCalendar = styled.div(_templateObject(), function (props) {
  return "\n        position: relative;\n        box-sizing: border-box;\n        font-family: \"Montserrat\";\n        font-size: ".concat(props.theme.components.calendar.fontSize, ";\n        line-height: ").concat(props.theme.components.calendar.lineHeight, ";\n        font-weight: ").concat(props.theme.components.calendar.fontWeight, ";\n        padding: ").concat(props.theme.components.calendar.padding, ";\n        background-color: ").concat(props.theme.components.calendar.backgroundColor, ";\n        width: ").concat(props.width, ";\n        height: ").concat(props.height, ";\n        box-shadow: ").concat(props.shadow ? '3px 0px 30px 0px rgba(0,0,0,0.25)' : '', ";\n        border-radius: 4px;\n        user-select: none;\n    ");
});
export var StyledControllers = styled.div(_templateObject2());
export var StyledSelect = styled.div(_templateObject3(), function (props) {
  return "\n        color: ".concat(props.theme.components.calendar.yearsColors, ";\n        cursor: pointer;\n        display: block;\n        font-size: ").concat(props.theme.components.calendar.yearsFontSize, ";\n        position: relative;\n    ");
});
export var StyledItems = styled.div(_templateObject4(), function (props) {
  return "\n        background-color: ".concat(props.theme.components.calendar.yearsItemsBackground, ";\n        border: ").concat(props.theme.components.calendar.yearsItemsBorder, ";\n        cursor: pointer;\n        max-height: 200px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        scrollbar-width: thin; /* Firefox only */\n        position: absolute;\n        z-index: 10;\n    ");
});
export var StyledItem = styled.div(_templateObject5(), function (props) {
  return "\n        font-size: ".concat(props.theme.components.calendar.yearsItemFontSize, ";\n        padding: 5px;\n\n        &:hover {\n            background-color: ").concat(props.theme.components.calendar.yearsItemBackground, ";\n        }\n    ");
});